export default __webpack_public_path__ + "static/media/hedgeblue_logo.71d5df61.png";